import { AsteriskIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import themeStore from '../../stores/themeStore';

const ThinkingText = observer(
    ({
        color = 'var(--color-primary)',
        children,
        className,
    }: {
        color?: string;
        children: React.ReactNode;
        className?: string;
    }) => {
        return (
            <span
                className={twMerge('thinking-text inline-flex items-center gap-1', className)}
                style={
                    {
                        '--thinking-base-color': color || 'var(--color-base-content)',
                        '--thinking-shimmer-color':
                            themeStore.themeToRender === 'dark'
                                ? 'color-mix(in oklab, var(--thinking-base-color) 100%, white 50%)' // 다크 테마에서는 부드럽게
                                : 'color-mix(in oklab, var(--thinking-base-color) 40%, white 100%)', // 라이트 테마에서는 흰색이 더 강조되게
                    } as React.CSSProperties
                }
            >
                <AsteriskIcon className="thinking-logo size-4" />
                {children}
            </span>
        );
    },
);

export default ThinkingText;
